import React, { Component } from "react";
import { gsap } from "gsap";
import logoE from "../../Resources/icons/etermax_brand-gamification_white.svg";
import * as PropTypes from "prop-types";
import { withRouter } from "react-router";
import { injectIntl } from "react-intl";
import {
  ADicon,
  ATicon,
  BGlogo,
  ContactIcon,
  MenuIcons,
  TTicon,
  Xlogo,
} from "./MenuIcons";
import MobilePopup from "./MobilePopup";
import DrawerMenu from "./DrawerMenu";
import {
  applyColourAccessibility,
  applyFontSizeAccessibility,
} from "../../Utilities/accessibility";
import { isPortrait } from "../../Utilities/utils";
import { isMobile } from "react-device-detect";

class MainMenu extends Component<{}> {
  componentDidMount() {
    let logoTl = gsap
      .timeline({
        scrollTrigger: {
          trigger: this.props.triggerId,
          start: this.props.start,
          endTrigger: this.props.endTriggerId ?? this.props.triggerId,
          end: this.props.end,
          scrub: true,
        },
      })
      .to("#scroll-icon", {
        opacity: 0,
        duration: 1,
      })
      .fromTo(
        "#to-top-icon",
        {
          scale: 0,
        },
        {
          scale: 1,
          duration: 1,
        }
      );

    if (!isPortrait()) {
      let d = 5;
      if (this.props.autoPlay) {
        logoTl = gsap.timeline();
        d = 2;
      }

      logoTl
        .to(
          "#logo",
          {
            opacity: 0,
            duration: d,
          },
          "0"
        )
        .to(
          "#logoX",
          {
            opacity: 1,
            duration: d,
            color: this.props.colorX,
          },
          "0"
        );
    }

    gsap.set(MenuIcons, { display: "flex" });

    if (this.props.hide) gsap.set(this.props.hide, { display: "none" });
  }

  getMobilePopup = () => <MobilePopup />;

  isLandscapeMode() {
    return isMobile && !isPortrait();
  }

  render() {
    return (
      <div className={"main-menu"}>
        {this.isLandscapeMode() && this.getMobilePopup()}
        <div className={"fixed-menu"}>
          {isPortrait() ? (
            <div
              id={"top-menu"}
              className={"top-menu clickable"}
              style={{
                backgroundColor: this.props.topMenu,
                fill: this.props.colorX,
              }}
            >
              {/*mobile*/}
              <BGlogo
                id={"bg-logo"}
                className={"bg-logo"}
                onClick={() => (window.location.href = `./`)}
              />
            </div>
          ) : (
            <div
              className={"logo-icon clickable logo-BG-menu"}
              onClick={() => (window.location.href = `./`)}
            >
              <img id={"logo"} className={"logo"} src={logoE} alt="etermaX" />
              <Xlogo id={"logoX"} className={"logoX"} />
            </div>
          )}
          <DrawerMenu />
          <ADicon
            id={"ac"}
            className={
              "menu-icons-container accessibility-contrast-icon clickable accessibility-img"
            }
            onClick={() => applyColourAccessibility()}
          />

          <ATicon
            id={"at"}
            className="menu-icons-container accessibility-text-icon accessibility-font clickable"
            onClick={() => applyFontSizeAccessibility()}
          />

          <TTicon
            id={"to-top-icon"}
            className={"menu-icons-container to-top-icon clickable"}
            onClick={() => {
              window.scrollTo({
                left: 0,
                top: 0,
                behavior: "smooth",
              });
            }}
          ></TTicon>

          <ContactIcon
            id={"contact-icon"}
            className={"menu-icons-container contact-icon clickable"}
            onClick={() =>
              this.props.history.push("/contact/" + this.props.location.search)
            }
          />

          <div
            id={"scroll-icon"}
            className={"icon-scroll " + this.props.iconScroll}
          >
            <h4 className={"icon-scroll-text"}>scroll</h4>
          </div>
        </div>
      </div>
    );
  }
}

MainMenu.propTypes = {
  triggerId: PropTypes.string.isRequired,
  start: PropTypes.string,
  endTriggerId: PropTypes.string,
  end: PropTypes.string,
  hide: PropTypes.arrayOf(PropTypes.string),
  colorX: PropTypes.string,
  autoPlay: PropTypes.bool,
  topMenu: PropTypes.string,
  iconScroll: PropTypes.string,
};

MainMenu.defaultProps = {
  triggerId: ".scene-container",
  start: "top -5%",
  end: "top top",
  colorX: "#fff",
  topMenu: "transparent",
  hide: [],
  iconScroll: "icon-scroll-center",
};

export default withRouter(injectIntl(MainMenu));
